module.exports = __webpack_public_path__ + "img/petition.4aa84e78.svg";